class Validation {
  static NameRegex = /^[A-Za-z\'\s\.\:\-]+$/;
}

export default Validation;
